import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ReactComponent as Verified } from '$icons/uncolored/verified.svg';

const SPKCandidateCardSkill = ({
  skill,
  index,
  containerRef,
  setOverflowIndex,
  isVerified,
}: {
  skill: string;
  index: number;
  containerRef: HTMLDivElement | null;
  setOverflowIndex: (index: number) => void;
  isVerified?: boolean;
}) => {
  const { ref, entry } = useInView({
    root: containerRef as HTMLDivElement,
    triggerOnce: true,
  });

  useEffect(() => {
    if (!entry?.intersectionRatio) return;

    if (entry.intersectionRatio < 1) {
      setOverflowIndex(index);
    }
  }, [entry?.intersectionRatio, index, setOverflowIndex]);

  return (
    <span
      ref={ref}
      className="text-xs rounded border border-gray-300 p-1 text-nowrap flex flex-row gap-2"
    >
      <span>{skill}</span>
      {isVerified && <Verified className="w-4 h-4 fill-spk-brightBlue" />}
    </span>
  );
};

SPKCandidateCardSkill.defaultProps = { isVerified: false };

export default SPKCandidateCardSkill;
